import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import useSliceFilterOpts from '../../../../../../../components/product/hooks/useSliceFilterOpts';
import { OWNER_STATUS_FILTER_ENUM } from '../constants';
import { SORT_DIRECTION } from '../../../../../../../constants/sort';
import { albumFolderShutterbugHomeFilterUpdate } from '../redux/albumFolderShutterbugFilterActions';

const useContextState = (initialFilter = {}) => {
  const albumFolderShutterbugFilter = useSelector(
    ({ albumFolderShutterbugFilter: filter }) => filter,
  );
  const dispatch = useDispatch();
  const onAlbumFolderShutterbugHomeFilterUpdate = useCallback(
    filter => dispatch(albumFolderShutterbugHomeFilterUpdate(filter)),
    [dispatch],
  );

  const { filter, onFilterUpdate } = useSliceFilterOpts({
    initialFilter: {
      owner_status: OWNER_STATUS_FILTER_ENUM.ALL,
      sort: {
        field: 'CREATED_AT',
        direction: SORT_DIRECTION.DESC,
      },
      search_query: '',
      ...albumFolderShutterbugFilter,
      ...initialFilter,
    },
  });

  useEffect(() => {
    onAlbumFolderShutterbugHomeFilterUpdate(filter);
  }, [filter]);

  return {
    filter,
    onFilterUpdate,
  };
};

export const AlbumFolderShutterbugFilterContext = createContext(null);

// Provider component
export const AlbumFolderShutterbugFilterContextProvider = ({
  children,
  initialFilter,
}) => (
  <AlbumFolderShutterbugFilterContext.Provider
    value={useContextState(initialFilter)}
  >
    {children}
  </AlbumFolderShutterbugFilterContext.Provider>
);

AlbumFolderShutterbugFilterContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialFilter: PropTypes.object,
};

const useAlbumFolderShutterbugFilterContext = () =>
  useContext(AlbumFolderShutterbugFilterContext);

export default useAlbumFolderShutterbugFilterContext;
